module.exports = __webpack_public_path__ + "static/media/setting_icon.c9dbf821.svg";